import React, { useEffect, useState, useRef } from 'react';
import { useCommonStore } from '../../stores/commonStore';
import { approveProduct } from '../../utils/api/requestApi';
import { useRequestorStore } from '../../stores/requestorStore';
import { IProduct } from '../../types/product';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { IRequestInfo } from '../../types/requester';
import Bottombar from '../Vendor/Bottombar';
import { fetchAllHotspotData } from '../../utils/api/feedbackApi';
import { useVendorStore } from '../../stores/vendorStore';
import { downloadModelUrl } from '../../utils/commonUtils';
import { getDimensionsFromUrl } from '../../utils/dimensions3DUtil';
import { ICoordinate, IhostspotRequest, IRotationRequest } from '../../types/hotspot';
import { initViewerConfig } from '../hotspotUtils/ViewerConfig';
import { IFrameRefHandler } from './IFrameRefHandler';

interface QueryParams {
    requestId: string;
    productId: string;
}

interface IStatus {
    label: string;
    type: 'error' | 'warn' | 'success' | 'basic';
}
interface LocationState {
    modelUrl?: string;
    routedActiveProduct?: any;
    userType?: string;
}

const Reviews = () => {
    const {
        state: { modelUrl, routedActiveProduct, userType }
    } = useLocation<LocationState>();

    const history = useHistory();
    const setLoading = useCommonStore((state) => state.setLoading);
    const productsData: IProduct[] = useRequestorStore((state) => state.products);
    const isProductFlagged: boolean = useCommonStore((state) => state.isProductFlagged);
    const setProducts = useRequestorStore((state) => state.setProducts);
    const setActiveRequest = useRequestorStore((state) => state.setActiveRequest);
    const activeRequest: IRequestInfo | null = useRequestorStore((state) => state.activeRequest);
    const [vendors, setVendors] = useState<any>(null);
    const setActiveProduct = useRequestorStore((state) => state.setActiveProduct);
    const fsns = useRequestorStore((state) => state.fsns);
    const setFsns = useRequestorStore((state) => state.setFsns);
    const { requestId, productId } = useParams<QueryParams>();
    const setActiveScreen = useRequestorStore((state) => state.setActiveScreen);
    const setShowActiveProduct = useRequestorStore((state) => state.setShowActiveProduct);
    const setShowActiveRequest = useRequestorStore((state) => state.setShowActiveRequest);
    const products: IProduct[] = useRequestorStore((state) => state.products);
    const setFlyoutRightOpen = useCommonStore((state) => state.setFlyoutRightOpen);
    const setShowComments = useVendorStore((state) => state.setShowComments);
    const setShowFsnDetails = useVendorStore((state) => state.setShowFsnDetails);
    const setToastMessage = useCommonStore((state) => state.setToastMessage);
    const [modelSize3D, setModelSize3D] = useState({});
    const activeProduct = useRequestorStore((state) => state.activeProduct);
    const setHotspot = useCommonStore((state) => state.setHotspotCoordinate);
    const setRotationConfig = useCommonStore((state) => state.setRotationConfig);
    const setHotspotCreation = useCommonStore((state) => state.setHotspotCreation);
    const setActiveHotspot = useCommonStore((state) => state.setActiveHostpot);

    const handleComments = () => {
        setShowActiveRequest(false);
        setShowActiveProduct(true);
        setFlyoutRightOpen(true);
        setShowComments(true);
        setShowFsnDetails(false);
    };

    const handleFsnDetails = () => {
        setShowActiveRequest(false);
        setShowActiveProduct(true);
        if (true) {
            setFlyoutRightOpen(true);
            setShowComments(false);
            setShowFsnDetails(true);
        }
    };

    const handlePrimaryButton = async () => {
        // approve model
        try {
            await approveProduct(productId);
            setToastMessage({ type: 'success', message: 'Approved' }, 1000, () => {
                history.goBack();
            });
        } catch (e) {
            setToastMessage({ type: 'error', message: 'Something went wrong' });
            console.error(e);
        }
    };
    const handleSecondaryButton = () => {
        // download model

        modelUrl && downloadModelUrl(modelUrl);
    };

    // 3d sdk

    const SDKURL = process.env.REACT_APP_THREED_SDK_STAGING_URL as string;

    const viewerconfig = {
        id: 'unique-product-id',
        thumbnail: routedActiveProduct?.productImages[0].url,

        model: {
            // url: 'https://t5flt.csb.app/scene.gltf'
            url: modelUrl
        },
        camera: {
            behaviours: {
                autoRotate: false
            },
            alpha: -1.5707963267948966,
            beta: 1.5707963267948966
        },
        ground: null,

        disableOnboarding: true
    };

    const handleOnload = async () => {
        const iFrameRef = IFrameRefHandler.getInstance(myref);
        const response = await fetchAllHotspotData(routedActiveProduct?.fsn as string);
        let cmd = initViewerConfig(response.data, modelUrl as string);
        IFrameRefHandler.createFromReactRef(myref);
        iFrameRef.postMessage(cmd);
    };

    const handleOnMessage = () => {
        window.addEventListener('message', (event) => {
            if (event.origin == 'https://static-assets-web.flixcart.com') {
                const data = JSON.parse(event.data);
                if (data.messageType === 'INFO') {
                    if (data.details.eventId === 'onModelLoadErrorObservable') {
                        return handleError(data);
                    }
                    if (data.details.eventId === 'onInitDoneObservable') {
                        setLoading(false);
                    }
                    if (data.details.eventId === 'onDoubleClickEventObservable') {
                        handleHotspotCreationEvent(data.details.data);
                    }
                    if (data.details.eventId === 'onHotspotClickedObservable') {
                        handleHotspotClicked(data.details.data.hotspotId);
                    }
                    if (data.details.eventId === 'onCameraCaptureEventObservable') {
                        handleCameraCaptureEvent(data.details.data);
                    }
                } else if (data.messageType === 'ERROR') {
                    console.error('Error', data);
                    setLoading(false);
                }
            }
        });
    };

    const handleHotspotClicked = (id: string) => {
        setActiveHotspot(id);
        setShowActiveRequest(false);
        setShowActiveProduct(true);
        setFlyoutRightOpen(true);
        setShowComments(true);
        setShowFsnDetails(false);
    };

    const handleCameraCaptureEvent = async (captureData: any) => {
        const target: ICoordinate = {
            x: captureData.target._x.toString(),
            y: captureData.target._y.toString(),
            z: captureData.target._z.toString()
        };

        const data: IRotationRequest = {
            alpha: captureData.alpha.toString(),
            beta: captureData.beta.toString(),
            radius: captureData.radius.toString(),
            target: target
        };
        setRotationConfig(data);
    };

    const getDimensionsFrom3D = async (modelUrl) => {
        const modelSize3D = getDimensionsFromUrl(modelUrl);
        const width3D = (await modelSize3D).width3D;
        const depth3D = (await modelSize3D).depth3D;
        const height3D = (await modelSize3D).height3D;
        const unit = (await modelSize3D).unit;
        setModelSize3D({ width3D: width3D, depth3D: depth3D, height3D: height3D, unit: unit });
    };

    const handleHotspotCreationEvent = async (modelData: any) => {
        setShowActiveRequest(false);
        setShowActiveProduct(true);

        const position: ICoordinate = {
            x: modelData.position._x.toString(),
            y: modelData.position._y.toString(),
            z: modelData.position._z.toString()
        };

        const target: ICoordinate = {
            x: modelData.camera.target._x.toString(),
            y: modelData.camera.target._y.toString(),
            z: modelData.camera.target._z.toString()
        };

        const data: IhostspotRequest = {
            position: position,
            alpha: modelData.camera.alpha.toString(),
            beta: modelData.camera.beta.toString(),
            radius: modelData.camera.radius.toString(),
            target: target,
            comment: ''
        };
        setHotspotCreation(true);
        setHotspot(data);
        setFlyoutRightOpen(true);
        setShowComments(true);
        setShowFsnDetails(false);
    };

    const handleError = (data) => {
        console.log('handleError on message', data);
        setToastMessage({ type: 'error', message: '3D Model is being processed, check back in some time.' }, 5000);
    };

    const myref: React.RefObject<HTMLIFrameElement> = useRef(null);

    useEffect(() => {
        const ref = myref?.current;
        if (ref) {
            ref?.addEventListener('load', handleOnload);
        }
        return () => {
            if (ref) {
                ref?.removeEventListener('load', handleOnload);
            }
            IFrameRefHandler.instance = null;
        };
    }, [myref]);

    useEffect(() => {
        setActiveProduct({ ...routedActiveProduct, modelSize3D: modelSize3D });
        setLoading(true);
        handleOnMessage();
        getDimensionsFrom3D(modelUrl);
    }, []);

    return (
        <div className="container mx-auto p-8 pb-0 h-full flex flex-col">
            <div className="pb-1">
                <div className="">
                    <div className="flex items-center mb-2">
                        <div className="text-xl font-semibold text-black mr-4 flex items-center">
                            Pending Reviews
                            <svg className="ml-4" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M0.380479 19.01C0.870479 19.5 1.66048 19.5 2.15048 19.01L10.4605 10.7C10.8505 10.31 10.8505 9.67999 10.4605 9.28999L2.15048 0.979988C1.66048 0.489988 0.870479 0.489988 0.380479 0.979988C-0.109521 1.46999 -0.109521 2.25999 0.380479 2.74999L7.62048 9.99999L0.370478 17.25C-0.109522 17.73 -0.109521 18.53 0.380479 19.01Z"
                                    fill="#AFAFAF"
                                />
                            </svg>
                        </div>
                        <div className="text-xl font-semibold text-black mr-4 flex items-center">
                            {`Request ${requestId}`}
                            <svg className="ml-4" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M0.380479 19.01C0.870479 19.5 1.66048 19.5 2.15048 19.01L10.4605 10.7C10.8505 10.31 10.8505 9.67999 10.4605 9.28999L2.15048 0.979988C1.66048 0.489988 0.870479 0.489988 0.380479 0.979988C-0.109521 1.46999 -0.109521 2.25999 0.380479 2.74999L7.62048 9.99999L0.370478 17.25C-0.109522 17.73 -0.109521 18.53 0.380479 19.01Z"
                                    fill="#AFAFAF"
                                />
                            </svg>
                        </div>
                        <div className="text-xl font-semibold text-black mr-4 flex items-center">{productId}</div>
                    </div>
                    <div className="text-gray-500 whitespace-no-wrap text-base capitalize">Select an item, verify the visual quality & drop your feedback</div>
                </div>
            </div>
            <div className=" h-full relative">
                <div className=" flex-row absolute right-3 bottom-8">
                    <button className=" block bg-fab-icon-bg p-3 mt-4 rounded-full" onClick={handleComments}>
                        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M20.9822 2C20.9822 0.9 20.0922 0 18.9922 0H2.99219C1.89219 0 0.992188 0.9 0.992188 2V14C0.992188 15.1 1.89219 16 2.99219 16H16.9922L20.9922 20L20.9822 2ZM15.9922 12H5.99219C5.44219 12 4.99219 11.55 4.99219 11C4.99219 10.45 5.44219 10 5.99219 10H15.9922C16.5422 10 16.9922 10.45 16.9922 11C16.9922 11.55 16.5422 12 15.9922 12ZM15.9922 9H5.99219C5.44219 9 4.99219 8.55 4.99219 8C4.99219 7.45 5.44219 7 5.99219 7H15.9922C16.5422 7 16.9922 7.45 16.9922 8C16.9922 8.55 16.5422 9 15.9922 9ZM15.9922 6H5.99219C5.44219 6 4.99219 5.55 4.99219 5C4.99219 4.45 5.44219 4 5.99219 4H15.9922C16.5422 4 16.9922 4.45 16.9922 5C16.9922 5.55 16.5422 6 15.9922 6Z"
                                fill="#2A55E5"
                            />
                        </svg>
                    </button>
                    <button className=" block bg-fab-icon-bg p-3 mt-4 rounded-full" onClick={handleFsnDetails}>
                        <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M18.998 16V2C18.998 0.9 18.098 0 16.998 0H2.99805C1.89805 0 0.998047 0.9 0.998047 2V16C0.998047 17.1 1.89805 18 2.99805 18H16.998C18.098 18 18.998 17.1 18.998 16ZM6.49805 10.5L8.99805 13.51L12.498 9L16.998 15H2.99805L6.49805 10.5Z"
                                fill="#2A55E5"
                            />
                        </svg>
                    </button>
                    {/* commented as no action on this button yet
                    <button className=" block bg-fab-icon-bg p-3 mt-4 rounded-full" onClick={handleFsnDetails}>
                        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10.9453 0C5.42531 0 0.945312 4.48 0.945312 10C0.945312 15.52 5.42531 20 10.9453 20C16.4653 20 20.9453 15.52 20.9453 10C20.9453 4.48 16.4653 0 10.9453 0ZM11.9453 17H9.94531V15H11.9453V17ZM14.0153 9.25L13.1153 10.17C12.6153 10.68 12.2553 11.14 12.0753 11.86C11.9953 12.18 11.9453 12.54 11.9453 13H9.94531V12.5C9.94531 12.04 10.0253 11.6 10.1653 11.19C10.3653 10.61 10.6953 10.09 11.1153 9.67L12.3553 8.41C12.8153 7.97 13.0353 7.31 12.9053 6.61C12.7753 5.89 12.2153 5.28 11.5153 5.08C10.4053 4.77 9.37531 5.4 9.04531 6.35C8.92531 6.72 8.61531 7 8.22531 7H7.92531C7.34531 7 6.94531 6.44 7.10531 5.88C7.53531 4.41 8.78531 3.29 10.3353 3.05C11.8553 2.81 13.3053 3.6 14.2053 4.85C15.3853 6.48 15.0353 8.23 14.0153 9.25Z"
                                fill="#2A55E5"
                            />
                        </svg>
                    </button> */}
                </div>
                <iframe height="100%" width="100%" title="test" className=" bg-transparent" frameBorder="0" scrolling="no" ref={myref} src={SDKURL} onError={handleError} />
            </div>

            <div className="sticky bottom-0 bg-white p-4 shadow-sm mt-auto">
                <Bottombar products={products} productId={productId} handlePrimaryButton={handlePrimaryButton} handleSecondaryButton={handleSecondaryButton} userType={userType} />
            </div>
        </div>
    );
};

export default Reviews;
